module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "model": "locations",
      "entity": _vm.model,
      "fields": _vm.locationFields,
      "after-submit": _vm.afterSubmit,
      "cancel": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70cf74c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setup-guide/LocationForm.vue
// module id = 1165
// module chunks = 2